export default "/images/98e6b6f121a9a224321813cdd58bcdda.png";